/**
 * What kind of failure a run's error text describes: Reporting's "What's failing" groups failed
 * runs by it, and the executions list's `failureCategory` filter lists the runs in one group.
 *
 * The rules are data so that both readers derive from them: `classifyFailure` here (the api
 * service classifies error strings in TypeScript) and `failureCategorySql` in `@fastn/db`
 * (the workflow service filters rows in SQL). Here rather than in `@fastn/db` because the request
 * contract (`@fastn/http`) validates the category name and cannot depend on the database package.
 *
 * First matching rule wins, over the lower-cased text; no text, or no match, is "unknown".
 * Needles are plain lower-case ASCII substrings, so the SQL form matches them with strpos and
 * no pattern escaping.
 */
export const FAILURE_CATEGORY_RULES = [
    { category: "auth", needles: ["401", "unauthor", "token expired"] },
    { category: "permission", needles: ["403", "forbidden", "permission"] },
    { category: "rate_limit", needles: ["rate limit", "429"] },
    { category: "timeout", needles: ["timeout", "etimedout"] },
    { category: "not_found", needles: ["not found", "404"] },
    { category: "validation", needles: ["validation", "invalid"] },
];
export const FAILURE_CATEGORIES = [
    "unknown",
    ...FAILURE_CATEGORY_RULES.map((r) => r.category),
];
export function classifyFailure(raw) {
    if (!raw)
        return "unknown";
    const lower = raw.toLowerCase();
    for (const rule of FAILURE_CATEGORY_RULES) {
        if (rule.needles.some((n) => lower.includes(n)))
            return rule.category;
    }
    return "unknown";
}
//# sourceMappingURL=failure-category.js.map